import { Heart } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import AIReadabilityBlock from "@/components/AIReadabilityBlock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/hooks/useLanguage";
import { immigrationContent } from "@/i18n/immigration-content";

const K1FianceVisa = () => {
  const { language } = useLanguage();
  const content = immigrationContent.k1Visa[language];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        {content.sections.map((section, idx) => (
          <div key={idx} className="mb-8">
            <h2 className="text-3xl font-bold mb-6">{section.title}</h2>
            <p className="text-xl text-muted-foreground mb-6">{section.content}</p>
            {section.items && (
              <ul className="list-disc pl-6 mb-6">
                {section.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            )}
          </div>
        ))}

        <h3 className="text-2xl font-bold mb-6">
          {language === 'en' ? 'Frequently Asked Questions' : language === 'es' ? 'Preguntas Frecuentes' : 'Câu Hỏi Thường Gặp'}
        </h3>
        <Accordion type="single" collapsible className="w-full">
          {content.faq.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  const aiKeyPoints = [
    "K-1 fiancé(e) visa for U.S. citizen petitioners",
    "Must marry within 90 days of entry to U.S.",
    "Form I-129F petition preparation",
    "Proof of bona fide relationship",
    "Evidence of in-person meeting within 2 years",
    "K-2 visa for children of fiancé(e)",
    "Adjustment of status after marriage",
    "Consular interview preparation"
  ];

  const aiFaqs = content.faq.map(f => ({ question: f.question, answer: f.answer }));

  return (
    <>
      <AIReadabilityBlock
        serviceName="K-1 Fiancé Visa Services"
        serviceDescription="K-1 fiancé visa attorney in Houston helping U.S. citizens bring their foreign fiancé(e)s to the United States for marriage and adjustment of status to permanent residence."
        keyPoints={aiKeyPoints}
        faqs={aiFaqs}
        areaServed="Houston, Texas"
      />
      <GenericPracticePage
        title={content.title}
        subtitle={content.subtitle}
        icon={<Heart className="h-20 w-20 mx-auto mb-6 text-accent" />}
        mainContent={mainContent}
      />
    </>
  );
};

export default K1FianceVisa;
